import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { Button } from "@components/Button";
import { Icon } from "@components/Icon";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";

const Container = styled.div`
  width: 100%;
  border-radius: 16px;
  background: ${COLOR_WHITE};
  padding: 1%;
  display: flex;
  flex-direction: row;
  gap: 18px;
`;

const SectionInput = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
`;

const SectionAction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

const ContainerVerticalField = styled.div`
  width: 100%;
`;

const InputGroup = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
`;

const ContainerHorizontalField = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const SectionSelectTimeFormat = styled.div`
  display: flex;
  flex-direction: row;
  height: 24px;
`;

const SectionSelectClockType = styled.div`
  display: flex;
  flex-direction: row;
  height: 24px;
`;

const SectionSelectImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
`;

const TIME_FORMAT_LIST = [
  { label: "12h", value: 12 },
  { label: "24h", value: 24 },
];

const CLOCK_TYPE_LIST = [
  { label: "digital", value: "DIGITAL" },
  { label: "analog", value: "ANALOG" },
];

const MAPPING_WIDGET_TYPE = {
  STATIC_IMAGE: "Widget image",
  STATIC_TIME: "Widget time",
  STATIC_DATE: "Widget date",
  STATIC_WEATHER: "Widget weather",
};

export const ImportMainWidget = ({
  index,
  item,
  onHandleUpdateWidgetInputValue = () => undefined,
  onHandleOpenSelectImage = () => undefined,
  onHandleDeleteBlock = () => undefined,
}) => {
  console.log("item :>> ", item);
  const timeFormat = _.get(item, ["attribute", "format"], "12");
  const clockType = _.get(item, ["attribute", "clockType"]);
  const widgetType = _.get(item, ["type"]);

  const onHandleChangeValue = ({ target }) => {
    const { name, value } = target;
    onHandleUpdateWidgetInputValue({ index, name, value });
  };

  const onHandleChangeValueTimeFormat = ({ value }) => {
    const name = "attribute";
    const updateFormat = {
      format: value,
      clockType: clockType,
    };
    onHandleUpdateWidgetInputValue({ index, name, value: updateFormat });
  };

  const onHandleChangeValueClockType = ({ value }) => {
    const name = "attribute";
    const updateFormat = {
      format: timeFormat,
      clockType: value,
    };
    onHandleUpdateWidgetInputValue({ index, name, value: updateFormat });
  };

  const onKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Container>
      <SectionInput>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Text color={COLOR_DARK} fontWeight="600" fontSize="12px">
            Type :
          </Text>
          <Text
            color={COLOR_DARK}
            fontWeight="500"
            fontSize="12px"
            style={{ marginLeft: 4 }}
          >
            {_.get(MAPPING_WIDGET_TYPE, [widgetType])}
          </Text>
        </div>

        <InputGroup>
          <ContainerHorizontalField>
            <Text
              color={COLOR_DARK}
              fontWeight="500"
              fontSize="12px"
              style={{ width: 15 }}
            >
              W
            </Text>
            <StyledInput
              style={{ height: 24, fontSize: 12 }}
              name={"width"}
              size="large"
              value={_.get(item, ["width"])}
              onKeyPress={onKeyPress}
              onChange={({ target }) => onHandleChangeValue({ target })}
            />
          </ContainerHorizontalField>
          <ContainerHorizontalField>
            <Text
              color={COLOR_DARK}
              fontWeight="500"
              fontSize="12px"
              style={{ width: 15 }}
            >
              H
            </Text>
            <StyledInput
              style={{ height: 24, fontSize: 12 }}
              name={"height"}
              size="large"
              value={_.get(item, ["height"])}
              onKeyPress={onKeyPress}
              onChange={({ target }) => onHandleChangeValue({ target })}
            />
          </ContainerHorizontalField>
        </InputGroup>
        <InputGroup>
          <ContainerHorizontalField>
            <Text
              color={COLOR_DARK}
              fontWeight="500"
              fontSize="12px"
              style={{ width: 15 }}
            >
              X
            </Text>
            <StyledInput
              style={{ height: 24, fontSize: 12 }}
              name={"position_x"}
              size="large"
              value={_.get(item, ["position_x"])}
              onKeyPress={onKeyPress}
              onChange={({ target }) => onHandleChangeValue({ target })}
            />
          </ContainerHorizontalField>
          <ContainerHorizontalField>
            <Text
              color={COLOR_DARK}
              fontWeight="500"
              fontSize="12px"
              style={{ width: 15 }}
            >
              Y
            </Text>
            <StyledInput
              style={{ height: 24, fontSize: 12 }}
              name={"position_y"}
              size="large"
              value={_.get(item, ["position_y"])}
              onKeyPress={onKeyPress}
              onChange={({ target }) => onHandleChangeValue({ target })}
            />
          </ContainerHorizontalField>
        </InputGroup>

        {widgetType === "STATIC_TIME" && (
          <InputGroup>
            <ContainerVerticalField>
              <Text color={COLOR_DARK} fontWeight="600" fontSize="12px">
                Format
              </Text>
              <SectionSelectTimeFormat>
                {_.map(TIME_FORMAT_LIST, (item, index) => {
                  const isActive = _.toInteger(timeFormat) === item?.value;

                  const borderRadiusStyle =
                    index === 0
                      ? {
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0,
                          borderRadius: "4px 0 0 4px",
                        }
                      : {
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                          borderRadius: "0 4px 4px 0",
                        };

                  return (
                    <Button
                      style={{ flex: 1, ...borderRadiusStyle }}
                      key={index}
                      onClick={() =>
                        onHandleChangeValueTimeFormat({ value: item?.value })
                      }
                      padding="0px"
                      height={"100%"}
                      color={isActive ? COLOR_GREEN : "#09090905"}
                      border={"0px"}
                    >
                      <Text
                        fontSize="12px"
                        fontWeight="500"
                        color={isActive ? COLOR_WHITE : COLOR_DARK}
                      >
                        {item?.label}
                      </Text>
                    </Button>
                  );
                })}
              </SectionSelectTimeFormat>
              <Text color={COLOR_DARK} fontWeight="600" fontSize="12px">
                Clock type
              </Text>
              <SectionSelectClockType>
                {_.map(CLOCK_TYPE_LIST, (item, index) => {
                  const isActive = clockType === item?.value;

                  const borderRadiusStyle =
                    index === 0
                      ? {
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0,
                          borderRadius: "4px 0 0 4px",
                        }
                      : {
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                          borderRadius: "0 4px 4px 0",
                        };

                  return (
                    <Button
                      style={{ flex: 1, ...borderRadiusStyle }}
                      key={index}
                      onClick={() =>
                        onHandleChangeValueClockType({ value: item?.value })
                      }
                      padding="0px"
                      height={"100%"}
                      color={isActive ? COLOR_GREEN : "#09090905"}
                      border={"0px"}
                    >
                      <Text
                        fontSize="12px"
                        fontWeight="500"
                        color={isActive ? COLOR_WHITE : COLOR_DARK}
                      >
                        {item?.label}
                      </Text>
                    </Button>
                  );
                })}
              </SectionSelectClockType>
            </ContainerVerticalField>
          </InputGroup>
        )}

        {widgetType === "STATIC_IMAGE" && (
          <InputGroup>
            <ContainerVerticalField>
              <Text color={COLOR_DARK} fontWeight="600" fontSize="12px">
                Image
              </Text>
              <Button
                onClick={() => onHandleOpenSelectImage({ index })}
                width="100%"
                padding="0px"
                margin="8px 0px 0px 0px"
              >
                <SectionSelectImage>
                  <Text color={"#8a8a8a"} fontWeight="500">
                    Select image
                  </Text>
                </SectionSelectImage>
              </Button>
            </ContainerVerticalField>
          </InputGroup>
        )}
      </SectionInput>
      <SectionAction>
        <Icon
          isCursor
          width={25}
          height={25}
          onClick={() => onHandleDeleteBlock(index)}
        >
          <ICON_TABLE_DELETE />
        </Icon>
      </SectionAction>
    </Container>
  );
};
